import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'phone' })

export class PhonePipe implements PipeTransform {
    transform(phone: string, style?: string) {
        if (!phone) {
            return '';
        }

        let areaCode: string, prefix: string, number: string, extension: string;

        const phoneclean = phone.replace(/[\(\)\- ]/g, '');

        if (phoneclean.length <= 3) {
            return phone;
        }

        areaCode = phoneclean.slice(0, 3);
        number = phoneclean.slice(3);

        if (phoneclean.length > 10) {
            extension = number.slice(7);
            prefix = number.slice(0, 3);
            number = number.slice(3, 7);
        } else {
            if (number.length > 3) {
                prefix = number.slice(0, 3);
                number = number.slice(3, 7);
                extension = '';
            } else {
                prefix = number;
                number = '';
                extension = '';
            }
        }

        switch (style) {
            case 'parensdash':
                return `(${areaCode}) ${prefix}${number ? '-' + number : number} ${extension && extension.length > 0 ? 'ext. ' + extension : ''}`.trim();
            case 'dash':
                return `(${areaCode}-${prefix}${number ? '-' + number : number} ${extension && extension.length > 0 ? 'ext. ' + extension : ''}`.trim();
            default:
                return (areaCode + prefix + number + ` ${extension && extension.length > 0 ? 'ext. ' + extension : ''}`).trim();
        }
    }
}
